export default __webpack_public_path__ + "static/media/aTrans.85f893a0.svg";